module.exports = __webpack_public_path__ + "img/category.8fa55636.png";